module.exports = __webpack_public_path__ + "static/media/Element_8_treatments.2419f1a0.svg";